import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/portfolio-next/src/components/sections/Footer.jsx");
